import type { ScenarioConfig, VisiblePopularFilter } from '@shared/types/Accommodations.types';

type VisibleFilters = NonNullable<ScenarioConfig['visibleFilters']>;

export type VisibleFilterSections = ReadonlyArray<Readonly<{ kind: 'price' }> | Readonly<{ kind: 'popular'; options: ReadonlyArray<VisiblePopularFilter> }>>;

/**
 * Turns `visibleFilters` into the panel's sections, in the listed order: the price range where `price` is listed,
 * and one popular-filters section at the place of the first popular filter.
 *
 * `walkToVenue` is dropped when the event has no venue location, because it would have nothing to measure from.
 */
export const buildVisibleFilterSections = (visibleFilters: VisibleFilters, hasVenueLocation = false): VisibleFilterSections => {
  const popularOptions = visibleFilters.filter(
    (visibleFilter): visibleFilter is VisiblePopularFilter => visibleFilter.id !== 'price' && (visibleFilter.id !== 'walkToVenue' || hasVenueLocation),
  );
  const entries: Array<VisibleFilterSections[number]> = [];
  let isPopularSectionAdded = false;
  for (const visibleFilter of visibleFilters) {
    if (visibleFilter.id === 'price') {
      entries.push({ kind: 'price' });
    } else if (!isPopularSectionAdded && popularOptions.length > 0) {
      entries.push({ kind: 'popular', options: popularOptions });
      isPopularSectionAdded = true;
    }
  }
  return entries;
};
